import {
  ModalForm,
  type ProFormInstance,
  ProFormText,
} from '@ant-design/pro-components';
import { history, useIntl } from '@umijs/max';
import { message } from 'antd';
import { forwardRef, useImperativeHandle, useRef } from 'react';
import { useImmer } from 'use-immer';
import { changePwd } from '@/api/user/login/service';

export interface ChangePwdRef {
  open: () => void;
}

const ChangePwdModal = forwardRef<ChangePwdRef>((props, ref) => {
  const intl = useIntl();
  const [visible, setVisible] = useImmer<boolean>(false);
  const formRef = useRef<ProFormInstance>(null);
  useImperativeHandle(ref, () => ({
    open: () => setVisible(true),
  }));

  return (
    <ModalForm
      formRef={formRef}
      width={460}
      modalProps={{
        destroyOnClose: true,
        maskClosable: false,
        onCancel: () => {
          setVisible(false);
        },
      }}
      onFinish={async (values) => {
        await changePwd(values as { oldPassword: string; newPassword: string });
        localStorage.removeItem('accessToken');
        message.success(
          intl.formatMessage({ id: 'globalHeader.changePwd.success' }),
        );
        history.replace({
          pathname: '/user/login',
        });
        setVisible(false);
      }}
      layout="horizontal"
      title={intl.formatMessage({ id: 'globalHeader.changePwd.title' })}
      open={visible}
      omitNil={false}
    >
      <ProFormText.Password
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'globalHeader.changePwd.oldPassword.required',
            }),
          },
        ]}
        name="oldPassword"
        label={intl.formatMessage({ id: 'globalHeader.changePwd.oldPassword' })}
      />
      <ProFormText.Password
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: 'globalHeader.changePwd.newPassword.required',
            }),
          },
        ]}
        name="newPassword"
        label={intl.formatMessage({ id: 'globalHeader.changePwd.newPassword' })}
      />
    </ModalForm>
  );
});

export default ChangePwdModal;
